var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.128 23.43c6.436 0 11.653-5.17 11.653-11.549 0-6.378-5.217-11.549-11.653-11.549C5.692.332.474 5.502.474 11.882c0 6.378 5.218 11.548 11.654 11.548Z",
    fill: "url(#facebook_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.057 12.333h-2.079v7.55h-3.15v-7.55H8.329V9.68h1.498V7.963c0-1.228.589-3.15 3.18-3.15l2.333.01v2.575h-1.694c-.277 0-.668.137-.668.723v1.561h2.355l-.276 2.651Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__a",
    x1: 12.128,
    y1: 0.332,
    x2: 12.128,
    y2: 23.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0822E"
  })))));
};
export default SvgFacebook;